import { render, staticRenderFns } from "./ProductFinder.vue?vue&type=template&id=2b1ed25a&scoped=true"
import script from "./ProductFinder.vue?vue&type=script&lang=js"
export * from "./ProductFinder.vue?vue&type=script&lang=js"
import style0 from "./ProductFinder.vue?vue&type=style&index=0&id=2b1ed25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1ed25a",
  null
  
)

export default component.exports